import { devtools as zustandDevtools } from 'zustand/middleware'

export const devtools = (process.env.NODE_ENV === 'production'
  ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fn: any) => fn
  : zustandDevtools) as unknown as typeof zustandDevtools
